import AddEditProjectForm from '@/modules/projects/add-projects';
import type { Organisation } from '@/services/types';

type Props = {
  data: Organisation | undefined;
};

export default function ProjectsView({ data }: Props) {
  return (
    <div className='max-w-4xl rounded p-6 mx-auto'>
      <div className='space-y-6'> 
        <AddEditProjectForm mode='add' orgId={data?.id} pageType='verify' />
      </div>
    </div>
  );
}
